import { all, fork } from 'redux-saga/effects';

import listenSubscribe from './listenSubscribe';

export default function* subscribeSaga() {
  yield all([fork(listenSubscribe)]);
}
